import { Box, ButtonBase, Typography, useMediaQuery} from '@mui/material'
import React from 'react'
// import MpSvgIcon from '../atom/MpSvgIcon'
import { theme } from '../../../theme/DashboardTheme'

interface IsThisYouProps {
  style?: any
  onAccuratePress: (accurate: boolean) => void
  validated: undefined | boolean
}

const Notme = (props: IsThisYouProps) => {
  const onThumbsUpPress = () => {
    if (props.validated !== true) {
      props.onAccuratePress(true)
    }
  }

  const onThumbsDownPress = () => {
    if (props.validated !== false) {
      props.onAccuratePress(false)
    }
  }
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Box
      sx={[
        {
          width:80,
        },
        props.style,
      ]}>
      {props.validated === true || props.validated === undefined ? (
        <ButtonBase sx={{width: '100%', display:'flex', justifyContent:'flex-start'
        }} onClick={onThumbsDownPress}>
          {/* <MpSvgIcon icon={'notMe'} /> */}
              <Typography variant={'label'} fontSize={!isMobile? '14px':'12px'} color={'#9135e0'}>
                Not Me
              </Typography>
        </ButtonBase>
      ) : (
        <ButtonBase sx={{width: '100%', display:'flex', justifyContent:'flex-start'
        }} onClick={onThumbsUpPress}>
          {/* <MpSvgIcon icon={'me'} /> */}
          <Typography
            variant={'label'}
            color={'success.main'}
            fontSize={!isMobile? '14px':'12px'}>
            This Is Me
          </Typography>
        </ButtonBase>
      )}
    </Box>
  )
}

export default Notme
